export default "__VITE_ASSET__Cw8nP1co__"